import { Component } from 'react';
import store, { history } from '../../../../../store';
import IgniteDataTable from '../../../../common/datatable';
import { deleteArticle } from '../../../../../actions/news';
import { dateTimeFormatUK } from '../../../../../utils/commonFunctions';

class ArticlesList extends Component {
  state = {
    delete: {
      show: false
    }
  };

  handleDelete = (result) => {
    const { id } = this.state.delete;

    this.setState({ delete: { show: false } });

    if (result) {
      store.dispatch(deleteArticle(id));
    }
  };

  render() {
    const columns = [
      {
        prop: 'title',
        title: 'Title',
        format(data, row) {
          return <a href={`/admin/news/edit-content/${row.id}`} target="_blank" rel="noopener noreferrer">{data}</a>;
        }
      },
      {
        prop: 'display-from-date',
        title: 'Display from',
        width: '160',
        format(data) {
          return dateTimeFormatUK(data);
        }
      },
      {
        prop: 'display-to-date',
        title: 'Display to',
        width: '160',
        format(data) {
          return dateTimeFormatUK(data);
        }
      },
      {
        prop: 'status',
        title: 'Status',
        width: '110',
      },
      {
        prop: 'eligible-user-groups',
        title: 'Eligible usergroups',
        width: 220,
        format(data) {
          return data.join(', ');
        }
      },
      {
        prop: 'eligible-groups',
        title: 'Eligible groups',
        width: 220,
        format(data) {
          return data.join(', ');
        }
      }
    ];

    const actions = [
      {
        label: 'Settings',
        color: 'grey',
        permissions: {
          action: 'update',
          subjectClass: 'Article'
        },
        callback: (row) => {
          history.push(`/admin/news/articles/${row.id}`);
        }
      }
    ];

    const { articles, paging } = this.props;
    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={articles}
          inlineActions={false}
          dataSize={paging ? +paging.number * +paging.size : articles.length}
          pagination={{
            page: this.props.currentPage,
            sizePerPage: 20,
            onPageChange: this.props.onPageChange,
          }}
          remote
        />
      </div>
    );
  }
}

export default ArticlesList;
